import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-6 md:px-10 py-14 md:py-16">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-20">
          <div className="lg:max-w-sm">
            <Link to="/" className="inline-block">
              <span className="text-xl font-heading font-semibold text-background-50">
                {t('site.name')}
              </span>
            </Link>
            <p className="mt-4 text-sm text-background-400 leading-relaxed">
              {t('footer.description')}
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-600 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="WeChat">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-600 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="Weibo">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-600 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="Email">
                <i className="ri-mail-line text-base"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">{t('footer.quickLinks')}</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200">{t('nav.home')}</Link>
              </li>
              <li>
                <Link to="/category/shengli-yuanli" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200">{t('nav.categories')}</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200">{t('nav.about')}</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">{t('footer.resources')}</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/category/shengli-yuanli" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200">生理原理</Link>
              </li>
              <li>
                <Link to="/category/jiqiao-fangfa" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200">技巧方法</Link>
              </li>
              <li>
                <Link to="/category/jiankang-zhishi" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200">健康知识</Link>
              </li>
              <li>
                <Link to="/category/changjian-wuqu" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200">常见误区</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">{t('footer.contact')}</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-mail-line text-sm"></i>
                <span>contact@health-guide.cn</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-phone-line text-sm"></i>
                <span>400-123-4567</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">{t('footer.copyright')}</p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">{t('footer.privacy')}</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">{t('footer.terms')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}